import { Tag, TagProps } from 'antd';

interface FilterTagProps extends Omit<TagProps, 'onChange'> {
  defaultValue: string;
  value?: string[];
  onChange?: (value: string[]) => void;
}

const FilterTag = ({ defaultValue, value = [], onChange, ...props }: FilterTagProps) => {
  return (
    <>
      {value.includes(defaultValue) && (
        <Tag
          closable
          onClose={() => onChange && onChange(value.filter((item) => item !== defaultValue))}
          {...props}
        />
      )}
    </>
  );
};

export default FilterTag;
